export enum locationStatus {
  inCreation = 'Wird erstellt',
  pending = 'Wird überprüft',
  notComplete = 'Nicht vollständig',
  approved = 'Freigegeben',
  declined = 'Abgelehnt',
}
